module.exports = __webpack_public_path__ + "img/TitansLeagueLogo.e88c3b76.png";